
export enum ExpectationStatusCd {
	EXCEPTION = 'Exception',
	MET = 'Met',
	NEW = 'New'}

